import { TransactionType, } from "@domains/aggregates/interfaces/Reports/iPNLTransactionReport";
import { pnlBothTransactionResMapper, pnlOriginalTxnMapper, pnlTransactionResponseMapper, } from "@domains/mapper/Reports/PNLMappter";
import urlConfig from "@adapters/infrastructures/urlConfig/Reports/reportsUrl";
import { getReportHeaders } from "@adapters/infrastructures/urlConfig/Reports/reportHeaders";
import { HoldingTransactionMapper } from "@domains/mapper/Reports/HoldingTransactionMapper";
import { getIsInIFrame } from "@domains/utils/tokenParser";
class PNLTransactionReportRepository {
    constructor(http, accountDetails) {
        this.http = http;
        this.accountDetails = accountDetails;
    }
    async getPNLTransactionData(requestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.pnlReportUrl + "/" + requestData.transactionType);
        if (requestData.accountIds)
            url.searchParams.append("accountId", requestData.accountIds);
        else
            url.searchParams.append("accountId", accountCode);
        url.searchParams.append("fromDate", requestData.fromDate);
        url.searchParams.append("toDate", requestData.toDate);
        url.searchParams.append("assetType", typeof requestData.assetType === "object"
            ? requestData.assetType.join(",")
            : requestData.assetType);
        url.searchParams.append("scripIdentifier", requestData.scripIdentifier.toString());
        if (requestData.transactionType === TransactionType.TRANSACTION) {
            url.searchParams.append("pageNumber", "1");
            url.searchParams.append("pageSize", "100");
        }
        let pnLransactionReportData = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            headers: getReportHeaders(accountCode),
            avoidAuthToken: getIsInIFrame(),
        });
        if (pnLransactionReportData.data &&
            requestData.transactionType === TransactionType.TRANSACTION) {
            return pnlBothTransactionResMapper(pnLransactionReportData.data);
        }
        else {
            return pnlTransactionResponseMapper(pnLransactionReportData.data);
        }
    }
    async sendEditSplitPNLTransactionData(requestData) {
        const url = new URL(urlConfig.downloadReportUrl + "edit-split");
        url.searchParams.append("approximated", requestData.approximated.toString());
        let pnLransactionReportData = await this.http.makeApiCall({
            method: "POST",
            url: url.toString(),
            body: requestData,
            avoidAuthToken: getIsInIFrame(),
        });
        if (pnLransactionReportData.data && pnLransactionReportData.data.status) {
            return Promise.resolve(true);
        }
        else {
            return Promise.resolve(false);
        }
    }
    async holdingTransactionDetails(req) {
        let accountCode;
        if (req.accountIds)
            accountCode = req.accountIds;
        else
            accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.holdingReportUrl + "/" + TransactionType.TRANSACTION);
        url.searchParams.append("accountId", accountCode);
        url.searchParams.append("scripIdentifier", req.scripIdentifier.toString());
        url.searchParams.append("date", req.date.toString());
        let holdingTransactions = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken: getIsInIFrame(),
        });
        return HoldingTransactionMapper(holdingTransactions.data);
    }
    /*------------------Edit split new flow-----------------------------*/
    //get original txns
    async getOriginalTxns(requestData) {
        const accountCode = await this.accountDetails.getAccountCode();
        const url = new URL(urlConfig.downloadReportUrl + "edit-split");
        url.searchParams.append("accountId", accountCode);
        new Set(requestData.pnLEditSplitRequests).forEach((x) => {
            url.searchParams.append("transactionId", x.transactionId.toString());
        });
        let pnlOriginalTxns = await this.http.makeApiCall({
            method: "GET",
            url: url.toString(),
            avoidAuthToken: getIsInIFrame(),
        });
        return pnlOriginalTxnMapper(pnlOriginalTxns.data.editSplitOriginalTransaction);
    }
}
export default PNLTransactionReportRepository;
